import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const fetchChildDocument = (id) => {
	return fetch(apiBasename + '/childDocument/' + id, authorization())
	.then(checkStatus)
	.then((res) => res.blob());
};

export const updateChildDocument = (id, changes) => {
	return fetch(apiBasename + '/childDocument/' + id, authorization({
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(changes)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const removeChildDocument = (id) => {
	return fetch(apiBasename + '/childDocument/' + id, authorization({
		method: 'DELETE'
	}))
	.then(checkStatus);
};
